import { render, staticRenderFns } from "./importwarehouseinfo.vue?vue&type=template&id=264e4f94"
import script from "./importwarehouseinfo.vue?vue&type=script&lang=js"
export * from "./importwarehouseinfo.vue?vue&type=script&lang=js"
import style0 from "./importwarehouseinfo.vue?vue&type=style&index=0&id=264e4f94&prod&scope=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports